<template>
  <div class="section-card">
    <div class="section-header">
      <p class="section-title">Attachments ({{ items.length }})</p>
    </div>
    <v-divider></v-divider>
    <div class="attachments-list">
      <div
        v-for="item in items"
        :key="item.url || item.description"
        class="attachment-row"
      >
        <div class="attachment-thumb">
          <v-img
            v-if="item.url"
            :src="item.url"
            :alt="item.description || 'Attachment'"
            class="attachment-image"
            contain
          />
        </div>
        <div class="attachment-copy">
          <p class="attachment-text">{{ item.description }}</p>
        </div>
        <!-- <v-icon size="18" class="attachment-chevron">mdi-open-in-new</v-icon> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type AttachmentItem = {
  url: string;
  description: string;
};

withDefaults(
  defineProps<{
    items?: AttachmentItem[];
  }>(),
  {
    items: () => [],
  },
);
</script>

<style scoped>
.section-card {
  background: #fff;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.section-title {
  margin: 0;
  font-size: var(--font-size-default);
  letter-spacing: 0.1em;
  text-transform: capitalize;
  color: var(--color-title);
  font-weight: 700;
}
.attachments-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.attachment-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* background: #f8fafc; */
  border-radius: 12px;
  padding: 10px;
}

.attachment-thumb {
  width: 100%;
  height: 160px;
  border-radius: 10px;
  overflow: hidden;
}

.attachment-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.attachment-text {
  margin: 0;
  font-size: 14px;
  color: #475569;
  line-height: 1.4;
}

.attachment-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.attachment-chevron {
  color: #94a3b8;
  align-self: flex-end;
}
</style>
